//CREATE_EMPLOYEE_DEPENDENT
export const CREATE_EMPLOYEE_DEPENDENT_REQUEST =
  "CREATE_EMPLOYEE_DEPENDENT_REQUEST";
export const CREATE_EMPLOYEE_DEPENDENT_SUCCESS =
  "CREATE_EMPLOYEE_DEPENDENT_SUCCESS";
export const CREATE_EMPLOYEE_DEPENDENT_FAIL = "CREATE_EMPLOYEE_DEPENDENT_FAIL";

//DELETE_EMPLOYEE_DEPENDENT
export const DELETE_EMPLOYEE_DEPENDENT_REQUEST =
  "DELETE_EMPLOYEE_DEPENDENT_REQUEST";
export const DELETE_EMPLOYEE_DEPENDENT_SUCCESS =
  "DELETE_EMPLOYEE_DEPENDENT_SUCCESS";
export const DELETE_EMPLOYEE_DEPENDENT_FAIL = "DELETE_EMPLOYEE_DEPENDENT_FAIL";

//GET_EMPLOYEE_DEPENDENT
export const GET_EMPLOYEE_DEPENDENT_REQUEST = "GET_EMPLOYEE_DEPENDENT_REQUEST";
export const GET_EMPLOYEE_DEPENDENT_SUCCESS = "GET_EMPLOYEE_DEPENDENT_SUCCESS";
export const GET_EMPLOYEE_DEPENDENT_FAIL = "GET_EMPLOYEE_DEPENDENT_FAIL";
